var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80682 6.21711C8.27936 6.8719 8.09309 7.82502 8.09309 9.02326V10.5116C8.09309 10.8199 7.8432 11.0698 7.53495 11.0698C7.22669 11.0698 6.97681 10.8199 6.97681 10.5116V9.02326C6.97681 7.75824 7.16263 6.47879 7.9375 5.51685C8.73337 4.52883 10.0441 4 12.0001 4C13.9561 4 15.2668 4.52883 16.0626 5.51685C16.8375 6.47879 17.0233 7.75824 17.0233 9.02326V10.5116C17.0233 10.8199 16.7734 11.0698 16.4652 11.0698C16.1569 11.0698 15.907 10.8199 15.907 10.5116V9.02326C15.907 7.82502 15.7208 6.8719 15.1933 6.21711C14.6869 5.58838 13.765 5.11628 12.0001 5.11628C10.2351 5.11628 9.31327 5.58838 8.80682 6.21711Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 13.6749C11.2806 13.6749 10.6976 14.2579 10.6976 14.9772C10.6976 15.6965 11.2806 16.2795 11.9999 16.2795C12.7192 16.2795 13.3022 15.6965 13.3022 14.9772C13.3022 14.2579 12.7192 13.6749 11.9999 13.6749ZM9.5813 14.9772C9.5813 13.6414 10.6641 12.5586 11.9999 12.5586C13.3357 12.5586 14.4185 13.6414 14.4185 14.9772C14.4185 16.313 13.3357 17.3958 11.9999 17.3958C10.6641 17.3958 9.5813 16.313 9.5813 14.9772Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69699 11.6501C5.31634 12.0308 5.11628 12.7398 5.11628 14.2322V15.7206C5.11628 17.2129 5.31634 17.922 5.69699 18.3026C6.07764 18.6833 6.78671 18.8834 8.27907 18.8834H15.7209C17.2133 18.8834 17.9224 18.6833 18.303 18.3026C18.6837 17.922 18.8837 17.2129 18.8837 15.7206V14.2322C18.8837 12.7398 18.6837 12.0308 18.303 11.6501C17.9224 11.2695 17.2133 11.0694 15.7209 11.0694H8.27907C6.78671 11.0694 6.07764 11.2695 5.69699 11.6501ZM4.90766 10.8608C5.64329 10.1252 6.79469 9.95312 8.27907 9.95312H15.7209C17.2053 9.95312 18.3567 10.1252 19.0923 10.8608C19.828 11.5964 20 12.7478 20 14.2322V15.7206C20 17.205 19.828 18.3563 19.0923 19.092C18.3567 19.8276 17.2053 19.9996 15.7209 19.9996H8.27907C6.79469 19.9996 5.64329 19.8276 4.90766 19.092C4.17203 18.3563 4 17.205 4 15.7206V14.2322C4 12.7478 4.17203 11.5964 4.90766 10.8608Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5845b1d9.svg";
export { ForwardRef as ReactComponent };